import { mapActions, mapGetters } from "vuex";

export default {
    name: "ComsobaseCourseActions",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "cosmobase/webinar"
      })
    },
    methods: {
      ...mapActions({
        generateCertificate: "cosmobase/GENERATE_CERTIFICATE"
      }),
      async generate() {
        // Open window immediately to prevent iOS Safari popup blocking
        const newWindow = window.open('', '_blank');
        
        try {
          const url = await this.generateCertificate(this.$route.params.id);
          if (newWindow && url) {
            newWindow.location.href = url;
          }
        } catch (error) {
          console.error('Помилка при завантаженні сертифікату:', error);
          if (newWindow) {
            newWindow.close();
          }
        }
      }
    }

}
